import PaymentMethod from 'components/Checkout2/SplitPayments/PaymentMethod';
import State from 'components/Payments/Transactions/State';
import { PaymentStates } from 'components/Payments/Transactions/Categories';
import { Spinner } from 'components/UI';
import { Option } from '@spike/model';
import React, { FunctionComponent } from 'react';
import { getOverviewCardIconSrc, isOverviewCardPayment, isOverviewCardPaymentMethod } from '../../clientOverviewUtils';
import ClientOverviewTransactionsEmpty from './ClientOverviewTransactionsEmpty';
import styles from './ClientOverviewTransactionHistory.module.scss';

export interface ClientOverviewTransaction {
    id?: string;
    date: string;
    amount: string;
    paymentMethodId: string;
    paymentMethodName: string;
    cardDigits: string | null;
    status: Option<string>;
    isRefund?: boolean;
}

interface ClientOverviewTransactionHistoryProps {
    transactions: ClientOverviewTransaction[];
    isLoading?: boolean;
    onViewAll?: () => void;
}

export const ClientOverviewTransactionHistory: FunctionComponent<ClientOverviewTransactionHistoryProps> = props => {
    return (
        <div className={styles.panel}>
            <div className={styles.panelHeader}>
                <h3 className={styles.panelTitle}>Transaction History</h3>
                {props.onViewAll && !props.isLoading && props.transactions.length > 0 ? (
                    <button
                        type="button"
                        className={styles.viewAll}
                        onClick={props.onViewAll}
                    >
                        View All
                    </button>
                ) : (
                    <span
                        className={styles.headerActionPlaceholder}
                        aria-hidden="true"
                    />
                )}
            </div>
            <div className={styles.scrollPanel}>
                <div className={styles.scrollPanelInner}>
                    {props.isLoading ? (
                        <div className={styles.loading}>
                            <Spinner />
                        </div>
                    ) : props.transactions.length === 0 ? (
                        <ClientOverviewTransactionsEmpty />
                    ) : (
                        props.transactions.map(transaction => (
                            <div
                                key={
                                    transaction.id ??
                                    `${transaction.date}-${transaction.paymentMethodId}-${transaction.status.id}`
                                }
                                className={styles.transactionRow}
                            >
                                <div>
                                    <p className={styles.transactionDate}>{transaction.date}</p>
                                    <div className={styles.transactionMeta}>
                                        <span className={styles.transactionAmount}>{transaction.amount}</span>
                                        {isOverviewCardPaymentMethod(transaction.paymentMethodId) ||
                                        Boolean(transaction.cardDigits) ||
                                        ['card', 'credit card'].includes(
                                            (transaction.paymentMethodName ?? '').trim().toLowerCase()
                                        ) ? (
                                            <div className={styles.cardPayment}>
                                                <img
                                                    src={getOverviewCardIconSrc(transaction.paymentMethodId || 'card')}
                                                    alt=""
                                                    className={styles.cardIcon}
                                                />
                                                {transaction.cardDigits && (
                                                    <span className={styles.cardDigits}>{transaction.cardDigits}</span>
                                                )}
                                            </div>
                                        ) : (
                                            <PaymentMethod
                                                paymentMethodId={transaction.paymentMethodId}
                                                paymentMethodName={transaction.paymentMethodName}
                                                cardDigits={transaction.cardDigits}
                                                className={styles.paymentMethod}
                                            />
                                        )}
                                    </div>
                                </div>
                                <State
                                    state={
                                        transaction.isRefund
                                            ? { id: PaymentStates.REFUNDED, name: 'Refunded' }
                                            : transaction.status
                                    }
                                    type="payment"
                                />
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default ClientOverviewTransactionHistory;
